import { Box, ButtonGroup, HStack, Heading, Text, VStack } from '@chakra-ui/react';
import { RiftboundButton } from '../ui/button';
import { RiftboundSwitch } from '../ui/switch';

export interface CollectionHoleControlsProps {
  holeOnly: boolean;
  onHoleOnlyChange: (on: boolean) => void;
  goal: 1 | 3;
  onGoalChange: (g: 1 | 3) => void;
  /** Show a hint when no set filter is selected (broad fetches can be slow). */
  noSetSelected?: boolean;
}

export function CollectionHoleControls({
  holeOnly,
  onHoleOnlyChange,
  goal,
  onGoalChange,
  noSetSelected = false,
}: CollectionHoleControlsProps) {
  return (
    <VStack align="stretch" gap={3} p={4} bg="bgElevated" borderRadius="lg">
      <Heading as="h2" size="sm">
        Collection mode
      </Heading>

      <HStack justify="space-between" align="center">
        <Text fontSize="sm" fontWeight="medium">
          Show missing cards only
        </Text>
        <RiftboundSwitch
          checked={holeOnly}
          onCheckedChange={(e) => onHoleOnlyChange(e.checked)}
          size="sm"
          flexShrink={0}
        />
      </HStack>

      {holeOnly && (
        <Box>
          <Text fontSize="xs" color="textMuted" mb={2}>
            Target copies per card
          </Text>
          <ButtonGroup size="sm" w="100%" attached>
            <RiftboundButton
              flex={1}
              treatment={goal === 1 ? 'primary' : 'secondary'}
              aria-pressed={goal === 1}
              onClick={() => onGoalChange(1)}
            >
              1× Master Set
            </RiftboundButton>
            <RiftboundButton
              flex={1}
              treatment={goal === 3 ? 'primary' : 'secondary'}
              aria-pressed={goal === 3}
              onClick={() => onGoalChange(3)}
            >
              3× Playset
            </RiftboundButton>
          </ButtonGroup>
          <Text fontSize="xs" color="textMuted" mt={2} lineHeight="short">
            {goal === 3
              ? 'Shows cards you own fewer than 3 copies of (playset).'
              : 'Shows cards you own zero copies of.'}
          </Text>
          {noSetSelected && (
            <Text fontSize="xs" color="orange.400" mt={2} lineHeight="short">
              Tip: filter by a set to keep loads fast.
            </Text>
          )}
        </Box>
      )}
    </VStack>
  );
}
